<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">卷详情（编织）</h1>-->
    <!--</header>-->
    <div class="mui-content pd-8">
      <div class="title-name">
        <span class="">卷详情（编织）</span>
      </div>
      <!--基础信息-->
      <div class="sampling-first" style="border-bottom: 1px dashed #CCCCCC;margin-top:15px;" >
        <!--第一行-->
        <div class="sampling-first-title">
          <h4>基础信息</h4>
        </div>
        <!--第二行内容-->
        <div class="sampling-first-content">
          <!--第2行-->
          <div style="display: flex;padding-top: 0px;padding-bottom: 3px;">
            <div class="flex-1" style="font-size: 13px; display: flex;">
              <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 50px;padding-left: 12px;">
                <span>物料:</span>
              </div>
              <div class="flex-3" style="white-space: nowrap;">
                <span>{{scxtwph}} {{scxtwpmc}}</span>
              </div>
            </div>
            <div class="flex-1" style="font-size: 13px;display: flex;padding-top: 0px;padding-bottom: 3px;">
              <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
                <span>已检数量:</span>
              </div>
              <div class="flex-3">
                <span>{{yjsl}}{{dw}}</span>
              </div>
            </div>
          </div>
          <!--第1行-->
          <div style="font-size: 13px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
              <span>外注订单:</span>
            </div>
            <div class="flex-9">
              <span>{{ddh}}</span>
            </div>
          </div>
          <!--第2行-->
          <div style="font-size: 13px;padding-top: 0px;padding-bottom: 3px;">
           <div class="sampling-first-content-left" style="flex: 0;text-align: left;min-width: 75px;padding-left: 12px;">
              <span>订单数量:</span>
            </div>
            <div class="flex-9">
              <span>{{sl}}{{dw}}</span>
            </div>
          </div>
          <!--第3行-->
          <!-- 2025 0A 0002 质检标签添加剩余未打卡量展示 ↓ -->
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;display: block;" class="hover-container">
            <div style="flex-grow: 1;display:flex">
              <div style="color: #333333;width:110px;"><!-- class="sampling-first-content-left" -->
                <span>订单未打卡数量:</span>
              </div>
              <div style="width:calc(100% - 110px);">
                <span>{{sysl}}{{dw}}</span>
                <span class="mui-icon mui-icon-info hover-trigger" style="font-size:20px;color:#1F6FB5" ></span>
              </div>
            </div>
            <div style="flex-grow: 1;font-size: 14px;padding-top: 0px;padding-bottom: 3px;margin-top:3px;" class="hover-content">
              <div class="hover-reveal" style="width:100%">订单未打卡数量 = 订单量 - TSD实际入库量（包含系统入库和无系统入库） - 生产未出库量 - 在途量</div>
            </div>
          </div>
          <!-- 2025 0A 0002 质检标签添加剩余未打卡量展示 ↑ -->
        </div>
      </div>
      <div class="sampling-first" style="border-bottom: 0px;">
        <div style="padding-top: 10px;position: relative">
          <!-- <span style="font-size: 25px;font-weight: bold;position: absolute;right: -1px;top: 15px;" @tap="scanQRCode"><img src="/static/images/richsacn.png" style="width:30px;"></span> -->
          <!--第一行-->
          <div class="form-group">
            <div class="input-label">
              <label>织机机台：</label>
            </div>
            <div class="form-input">
              <input type="text" v-model="machineno" disabled/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>坯布品番：</label>
            </div>
            <div class="form-input">
              <input type="text" v-model="clothcode" disabled/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>外注卷号：</label>
            </div>
            <div class="form-input">
              <input type="text" v-model="wzrollno" disabled/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>匹数：</label>
            </div>
            <div class="form-input">
              <input type="text" v-model="boltnum" disabled/>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">净重：</label>
            <div class="form-input" style="display: flex;">
              <input type="text" style="flex:11;"v-model="netweight" disabled />
              <div class="input-label" style="flex:3;text-align: center;">
                {{dw}}
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">落布日期：</label>
            <div class="form-input" style="display: flex;">
              <input type="text" style="flex: 11;" v-model="fallingtime" disabled />
              <div class="input-label" style="flex:3;"></div>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>挡车记录：</label>
            </div>
            <div class="form-input">
              <textarea rows="" cols="" v-model="dcremark" disabled></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>验布记录：</label>
            </div>
            <div class="form-input">
              <textarea rows="" cols="" v-model="checkremark" maxlength="200"></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注：</label>
            </div>
            <div class="form-input">
              <textarea v-model="remark" disabled></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注1：</label>
            </div>
            <div class="form-input">
              <textarea v-model="remark1" disabled></textarea>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label>备注2：</label>
            </div>
            <div class="form-input">
              <textarea v-model="remark2" disabled></textarea>
            </div>
          </div>
          <div class="form-group" v-if="!wph.startsWith('0103')">
            <label class="input-label"></label>
            <div class="form-input" style="padding-top: 0px;">
              <div class="mui-input-row mui-checkbox mui-left">
                <label style="font-size: 14px;" for="changeyarn_flg">是否换纱</label>
                <input type="checkbox" v-model="changeyarn_flg" disabled>
              </div>
              <div class="mui-input-row mui-checkbox mui-left">
                <label style="font-size: 14px;" for="clothhead_flg">布头标记</label>
                <input type="checkbox" v-model="clothhead_flg" disabled>
              </div>
            </div>
          </div>
          <div class="form-group" style="width:100%;margin-top: 10px;margin-bottom: 10px;">
            <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;width: 80px;" @tap="finish">完成</button>
            <button type="button" class="mui-btn mui-btn-default" style="margin: auto;width: 80px;" @tap="conadd">继续扫描</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "qualityDetailYB",
  data() {
    return {
      ddh: "",
      wph: "",
      scxtwph: "",
      scxtwpmc: "",
      yjsl: "",
      sl: "",
      dw: "",
      tsdrollno: "",
      machineno: "", // 织机机台
      clothcode: "", // 坯布品番
      clothcodeinfo: null,
      clothcodeLst: [],
      wzrollno: "", // 外注卷号
      boltnum: "", // 匹数
      clothremakflg: "", // 坯布区分
      length: "", // 长度
      netweight: "", // 净重
      fallingtime: "", // 落布时间
      remark: "", // 备注
      shipmentno: "",
      statusflg: "", // 状态 0：质检登录
      changeyarnflg: "0", // 0：未换纱 1：换纱
      changeyarn_flg: false,
      clothheadflg: "", // 0：非布头 1：布头
      clothhead_flg: false,
      dcremark: "", // 挡车记录
      checkremark: "", // 验布记录
      bdoresult: "",
      deviceLst: [],
      device: null,
      fname: "",
      zdflg: false,
      breadth: "",// 幅宽
      gauge_length: "",// 规格幅长  
      fkdw: "",// 幅宽单位  
      fcdw: "",// 幅长单位
      bcc: "",// 编成长
      bccdw: "",// 编成长单位
      bzzl: "",// 标准重量  
      pbcf: "",// 坯布成分
      inspectflag: "",// 0：质检 1：不质检
      ddqf: "",
      remark1: "",
      remark2: "",
      sysl:"" // 20250808 剩余打卡数量
    }
  },
  created() {
    this.nyy.wxInit();
  },
  activated() {
    var v = this;
    const para = getJsonPara(v.$route);
    if (para) {
      v.ddh = para.ddh;
      v.wph = para.wph;
      v.tsdrollno = para.tsdrollno;
      v.getJDetail();
    }
  },
  methods: {
    scanQRCode(){
      var v = this;
      // 需校验当前扫码是否是该出库单号下指示的明细
      wx.scanQRCode({
        desc: 'scanQRCode desc',
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          // 回调
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          if (!result > 1) {
            mui.toast('无效二维码')
          } else {
            // 需校验当前扫码是否是该出库单号下指示的明细
            // TSD卷号截取，获取前8位 2020/06/28
            var rollstr = result.substr(0,8);
            v.tsdrollno = rollstr;
            //v.tsdrollno = result;
            v.getJDetail();
          }
        },
        error: function(res) {
          if (res.errMsg.indexOf('function_not_exist') > 0) {
            mui.toast('版本过低请升级')
          }
        }
      });
    },
    getpbph() {
      var v = this;
      for (var i = 0; i < v.clothcodeLst.length; i++) {
        if (v.clothcode == v.clothcodeLst[i].pbph) {
          v.clothcodeinfo = v.clothcodeLst[i];
          return;
        }
      }
    },
    getJDetail() {
      var v = this;
      v.nyy.doPost("/Quality/getJDetail", {
          ddh: v.ddh,
          wph: v.wph,
          tsdrollno: v.tsdrollno
        },
        function(result) {
          if (result.status) {
            var info = result.data.info;
            v.scxtwph = info.scxtwph;
            v.scxtwpmc = info.scxtwpmc;
            v.sl = info.sl;
            v.dw = info.dw;
            v.yjsl = info.yjsl;
            v.fname = info.fname;
            v.inspectflag = info.inspectflag;
            v.ddqf = info.ddqf;
            // 坯布品番
            v.clothcodeLst = result.data.pbphInfoList;
            //v.clothcodeLst = [{"pbph":"WZ3450","gcfc":50.0,"bzzl":6.23,"fcdw":"M","pbcf":"PE100","gcfk":148.0,"fkdw":"C","bcc":1.0,"bccdw":"M"},{"pbph":"WZ3450-1","gcfc":50.0,"bzzl":0.01,"fcdw":"M","pbcf":"PE100","gcfk":148.0,"fkdw":"C","bcc":1.0,"bccdw":"M"}];//result.data.pbphInfoList;

            v.deviceLst = result.data.deviceLst;
            v.device = (v.deviceLst && v.deviceLst.length>0)?v.deviceLst[0]:null;

            // 20250811 剩余未打卡数量 ↓
            // v.sysl = info.sysl;
            // 20250811 剩余未打卡数量 ↑

            if (v.tsdrollno == "") {
              v.init();
            } else {
              v.machineno = info.machineno; // 织机机台
              v.clothcode = info.clothcode; // 坯布品番
              v.getpbph();
              v.wzrollno = info.wzrollno; // 外注卷号
              v.boltnum = info.boltnum; // 匹数
              v.clothremakflg = info.clothremakflg; // 坯布区分
              v.length = info.length; // 长度
              v.netweight = info.netweight; // 净重
              v.fallingtime = info.fallingtime; // 落布时间
              v.remark = info.remark; // 备注
              v.remark1 = info.remark1;
              v.remark2 = info.remark2;
              v.statusflg = info.statusflg;
              v.bdoresult = info.bdoresult;

              v.dcremark = info.dcremark; // 挡车记录
              v.checkremark = info.checkremark; // 验布记录
              v.changeyarnflg = info.changeyarnflg; // 0：未换纱 1：换纱
              v.changeyarn_flg = (info.changeyarnflg == '1' ? true : false);
              v.clothheadflg = info.clothheadflg; // 0：非布头 1：布头
              v.clothhead_flg = (info.clothheadflg == '1' ? true : false);

              v.zdflg = info.zdflg;// 是否已被指定
              if((v.statusflg=='0') && (!v.zdflg) && (v.inspectflag=='0') && (v.ddqf=='2')){

              }else{
                mui.alert("当前卷信息无法修改","提示",function(){
                  v.$router.go(-1);
                });
              }
            }
            
            // 20250811 剩余未打卡数量 ↓
            v.getContractSYAmount();
            // 20250811 剩余未打卡数量 ↑

          }else{
            mui.toast(result.message);
          }
        }
      );
    },
    init() {
      var v = this;
      v.machineno = ""; // 织机机台
      v.clothcodeinfo = (v.clothcodeLst && v.clothcodeLst.length>0)?v.clothcodeLst[0]:null;
      v.wzrollno = ""; // 外注卷号
      v.boltnum = ""; // 匹数
      v.netweight = ""; // 净重

      v.dcremark = ""; // 挡车记录
      v.checkremark = ""; // 验布记录
      v.changeyarnflg = "0"; // 0：未换纱 1：换纱
      v.changeyarn_flg = false;
      v.clothheadflg = "0"; // 0：非布头 1：布头
      v.clothhead_flg = false;

      var date = new Date(); //获取当前时间
      var now_date = v.getFormatDate(date) + " " + v.GetDefalutTime();
      v.fallingtime = now_date; // 落布时间

      v.remark = ""; // 备注
      v.remark1 = "";
      v.remark2 = "";
    },
    GetDefalutTime(){
      // 获取系统时间
      var systemDate = new Date();
      var sysTime = "";
      if (systemDate.getHours() < 10) {
          sysTime += "0" + systemDate.getHours();
      } else {
          sysTime += systemDate.getHours();
      }
      if (systemDate.getMinutes() < 10) {
          sysTime += ":0" + systemDate.getMinutes();
      } else {
          sysTime += ":" + systemDate.getMinutes();
      }
      return sysTime;
    },
    getFormatDate(date) {
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    // 完成
    finish() {
      var v = this;
      if (!v.check()) return;
      v.updateJ(function(){
        v.$router.go(-1);
      });
    },
    check() {
      var v = this;
      // 是否自主质检
      if (v.inspectflag == "0") {
        if (v.checkremark == "") {
          mui.toast("请输入验布记录");
          return false;
        }
      }
      return true;
    },
    // 继续添加
    conadd() {
      var v = this;
      if (!v.check()) return;
      v.updateJ(function(){
        v.tsdrollno = "";
        v.scanQRCode();
      });
    },
    updateJ(callback){
      var v = this;
      // 可修改验布记录
      var postMap = {
        "ddh": v.ddh,
        "wph": v.wph,
        "tsdrollno": v.tsdrollno,
        "checkremark": v.checkremark,
        "wzrollno": (v.wzrollno).toUpperCase(), // 外注卷号可编辑 2020/1/7 课题95
        "boltnum": v.boltnum, // 匹数 可编辑 2020/1/7 课题95
        "netweight": v.netweight, // 净重 可编辑 2020/1/7 课题95
        "length" : v.length, // 匹数变更时，长度对应变更 2020/4/24 课题95
        "machineno": (v.machineno).toUpperCase(), // 织机机台
        "clothcode":v.clothcode, // 坯布品番
        "fallingtime": v.fallingtime, // 落布时间
        "remark": v.remark, // 备注
        "dcremark": v.dcremark, // 挡车记录
        "biztype": "YB"
      };
      v.nyy.doPost("/Quality/updateJ", postMap,
        function(result) {
          if (result.status) {
            if (callback) callback();
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    // 获取订单剩余数量
    getContractSYAmount(callback) {
      var v = this;
      v.nyy.doPost("/Quality/getContractSYAmount", {
        ddh: v.ddh,
        wph: v.wph
      },
      function(result) {
        if (result.status) {
          // 20250811 剩余未打卡数量 ↓
          v.sysl = result.data.info.sysl;
          // 20250811 剩余未打卡数量 ↑
          if (callback) callback();
        } else {
          mui.toast(result.message);
        }
      }
      );
    }
  }
}
</script>
<style scoped>
@import "../../static/css/sampling.css";
@import "../../static/css/samplinghistory.css";
@import "../../static/css/filterorder.css";
@import "../../static/css/quality.css";
</style>



// WEBPACK FOOTER //
// src/components/qualityDetailYB.vue